/* Rahul Ecommerce slider engine
   Touch swipe, mouse drag, arrows, dots, autoplay, infinite loop (clone based), keyboard, editor support. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function canHover() { return !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches); }

  function Slider(el) {
    var s = this;
    s.el = el;
    s.vp = el.querySelector('[data-viewport]');
    s.track = el.querySelector('[data-track]');
    s.dotsEl = el.querySelector('[data-dots]');
    s.orig = [].slice.call(s.track.children);
    s.n = s.orig.length;
    s.autoplay = parseInt(el.getAttribute('data-autoplay') || '0', 10);
    s.loopWanted = el.getAttribute('data-loop') !== 'false';
    s.pvM = parseInt(el.getAttribute('data-pv-mobile') || '1', 10);
    s.pvD = parseInt(el.getAttribute('data-pv-desktop') || '1', 10);
    s.bp = parseInt(el.getAttribute('data-breakpoint') || '750', 10);
    s.cur = parseInt(el.getAttribute('data-start') || '0', 10) || 0; s.idx = 0; s.off = 0; s.pv = 1;
    s.lock = false; s.dragging = false; s.moved = false; s.hover = false; s.focus = false;
    s.timer = null; s.dur = 500;

    var prev = el.querySelector('[data-prev]');
    var next = el.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { s.go(-1); s.restart(); });
    if (next) next.addEventListener('click', function () { s.go(1); s.restart(); });

    s.bindDrag();
    /* Pause on hover for real mice only; touch taps must never leave autoplay paused */
    el.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse' && canHover()) s.hover = true; });
    el.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') s.hover = false; });
    el.addEventListener('focusin', function () { s.focus = true; });
    el.addEventListener('focusout', function () { s.focus = false; });
    el.addEventListener('keydown', function (e) {
      if (e.target.closest('input,textarea,select')) return;
      if (e.key === 'ArrowLeft') { s.go(-1); s.restart(); }
      if (e.key === 'ArrowRight') { s.go(1); s.restart(); }
    });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) s.restart(); });

    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(function () { if (s.el.isConnected) s.build(); }, 150);
    });
    s.build();
  }

  Slider.prototype.build = function () {
    var s = this, i;
    [].slice.call(s.track.querySelectorAll('.is-clone')).forEach(function (c) { c.parentNode.removeChild(c); });
    s.pv = Math.max(1, Math.min(window.innerWidth >= s.bp ? s.pvD : s.pvM, s.n));
    s.canMove = s.n > s.pv;
    s.loop = s.loopWanted && s.canMove;
    s.el.style.setProperty('--pv', s.pv);
    s.el.classList.toggle('is-static', !s.canMove);
    s.off = 0;
    if (s.loop) {
      var head = document.createDocumentFragment(), tail = document.createDocumentFragment();
      for (i = 0; i < s.pv; i++) {
        var a = s.orig[s.n - 1 - i].cloneNode(true), b = s.orig[i].cloneNode(true);
        [a, b].forEach(function (c) { c.classList.add('is-clone'); c.setAttribute('aria-hidden', 'true'); c.removeAttribute('data-shopify-editor-block'); });
        head.insertBefore(a, head.firstChild);
        tail.appendChild(b);
      }
      s.track.insertBefore(head, s.track.firstChild);
      s.track.appendChild(tail);
      s.off = s.pv;
    }
    s.slides = [].slice.call(s.track.children);
    s.dur = (parseFloat(getComputedStyle(s.track).transitionDuration) || 0.5) * 1000;
    s.maxCur = s.loop ? s.n - 1 : s.n - s.pv;
    s.cur = Math.min(s.cur, Math.max(0, s.maxCur));
    s.idx = s.off + s.cur;
    s.buildDots();
    s.set(s.idx, false);
    s.updateDots();
    s.restart();
  };

  Slider.prototype.buildDots = function () {
    var s = this;
    if (!s.dotsEl) return;
    s.dotsEl.innerHTML = '';
    if (!s.canMove) return;
    var count = s.maxCur + 1;
    for (var k = 0; k < count; k++) {
      (function (k) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'slider__dot';
        b.setAttribute('aria-label', 'Go to slide ' + (k + 1));
        b.addEventListener('click', function () { s.goTo(k); s.restart(); });
        s.dotsEl.appendChild(b);
      })(k);
    }
  };

  Slider.prototype.updateDots = function () {
    var s = this;
    if (s.dotsEl) {
      [].slice.call(s.dotsEl.children).forEach(function (d, k) {
        d.classList.toggle('is-active', k === s.cur);
        if (k === s.cur) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
    }
    s.el.dispatchEvent(new CustomEvent('slider:change', { detail: { index: s.cur } }));
  };

  Slider.prototype.set = function (i, animate) {
    var s = this, sl = s.slides[i];
    if (!sl) return;
    s.track.style.transition = animate ? '' : 'none';
    s.track.style.transform = 'translate3d(' + (-sl.offsetLeft) + 'px,0,0)';
    if (!animate) { void s.track.offsetWidth; }
  };

  Slider.prototype.go = function (dir) {
    var s = this;
    if (!s.canMove || s.lock) return;
    if (s.loop) {
      s.idx += dir;
      s.cur = ((s.idx - s.off) % s.n + s.n) % s.n;
      s.lock = true;
      s.set(s.idx, true);
      setTimeout(function () {
        if (s.idx >= s.off + s.n) s.idx -= s.n;
        else if (s.idx < s.off) s.idx += s.n;
        s.set(s.idx, false);
        s.lock = false;
      }, s.dur + 30);
    } else {
      var c = s.cur + dir;
      if (c > s.maxCur) c = 0;
      if (c < 0) c = s.maxCur;
      s.cur = c; s.idx = c;
      s.set(s.idx, true);
    }
    s.updateDots();
  };

  Slider.prototype.goTo = function (k) {
    var s = this;
    if (!s.canMove || s.lock) return;
    k = Math.max(0, Math.min(k, s.maxCur));
    s.cur = k; s.idx = s.off + k;
    s.set(s.idx, true);
    s.updateDots();
  };

  Slider.prototype.bindDrag = function () {
    var s = this, sx = 0, base = 0, dx = 0, pid = null;
    s.vp.addEventListener('dragstart', function (e) { e.preventDefault(); });
    s.vp.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (!s.canMove || s.lock) return;
      sx = e.clientX; dx = 0; pid = e.pointerId;
      base = -s.slides[s.idx].offsetLeft;
      s.dragging = true; s.moved = false;
    });
    s.vp.addEventListener('pointermove', function (e) {
      if (!s.dragging) return;
      dx = e.clientX - sx;
      if (!s.moved) {
        if (Math.abs(dx) < 6) return;
        s.moved = true;
        s.track.style.transition = 'none';
        s.vp.classList.add('is-dragging');
        try { s.vp.setPointerCapture(pid); } catch (err) { /* ignore */ }
      }
      s.track.style.transform = 'translate3d(' + (base + dx) + 'px,0,0)';
    });
    function end() {
      if (!s.dragging) return;
      s.dragging = false;
      s.vp.classList.remove('is-dragging');
      if (s.moved) {
        s.justDragged = true;
        setTimeout(function () { s.justDragged = false; }, 60);
        var threshold = Math.min(60, s.vp.offsetWidth * 0.15);
        s.track.style.transition = '';
        if (Math.abs(dx) > threshold) s.go(dx < 0 ? 1 : -1); else s.set(s.idx, true);
      }
      s.restart();
    }
    s.vp.addEventListener('pointerup', end);
    s.vp.addEventListener('pointercancel', end);
    s.vp.addEventListener('click', function (e) {
      if (s.justDragged) { e.preventDefault(); e.stopPropagation(); }
    }, true);
  };

  Slider.prototype.stop = function () { clearInterval(this.timer); this.timer = null; };
  Slider.prototype.restart = function () {
    var s = this;
    s.stop();
    if (s.autoplay > 0 && s.canMove && !reduce && !s.editorPaused) {
      s.timer = setInterval(function () {
        if (!s.el.isConnected) { s.stop(); return; }
        if (s.hover || s.focus || s.dragging || document.hidden) return;
        s.go(1);
      }, s.autoplay);
    }
  };

  function init(root) {
    if (!root || !root.querySelectorAll) return;
    var list = [].slice.call(root.querySelectorAll('[data-slider]'));
    if (root.matches && root.matches('[data-slider]')) list.push(root);
    list.forEach(function (el) {
      if (el._slider || !el.querySelector('[data-track]')) return;
      el._slider = new Slider(el);
    });
  }
  window.RahulSlider = { init: init };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var sl = e.target.closest && e.target.closest('[data-slider]');
    if (!sl || !sl._slider) return;
    var s = sl._slider, k = s.orig.indexOf(e.target);
    s.editorPaused = true; s.stop();
    if (k > -1) s.goTo(k);
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var sl = e.target.closest && e.target.closest('[data-slider]');
    if (sl && sl._slider) { sl._slider.editorPaused = false; sl._slider.restart(); }
  });
})();
